/**
 * 报表过滤条件
 *
 */
define('directives/myreport/public-filter.directives',['app', 'mainCons'], function (app, mainCons) {
    return app.directive('reportFilter', ['OpenApp', 'OpenOther', 'auiDialog', 'reportUtil','auiTeamAccountService', function (OpenApp, OpenOther, auiDialog, reportUtil,auiTeamAccountService) {
        return {
            restrict: 'E',
            scope: {
                serviceItem: "=",
                payModel: "="
            },
            replace: true,
            require: "?ngModel",
            templateUrl: '../refactor/directives/myreport/public-filter.template.html',
            link: function ($scope, $element, attr, ngModelCtrl) {
                $scope.showMore = true;
                $scope.preSettlementSettleTypeCons = mainCons.reportAll.preSettlementSettleTypeCons;
                $scope.preSettlementStatusCons = mainCons.reportAll.preSettlementStatusCons;
                $scope.tradeStatusMarketCons = mainCons.reportAll.tradeStatusMarketCons;
                $scope.tradeSDKCons = mainCons.reportAll.tradeSDKCons;
                $scope.tradeSDKQueryTypeCons = mainCons.reportAll.tradeSDKQueryTypeCons;
                $scope.tradeStatusGameTicketCons = mainCons.reportAll.tradeStatusGameTicketCons;
                $scope.tradeStatusPaymentCons = mainCons.reportAll.tradeStatusPaymentCons;
                $scope.serviceTypePaymentCons = mainCons.reportAll.serviceTypePaymentCons;
                $scope.payTypePaymentCons = mainCons.reportAll.payTypePaymentCons;
                $scope.sdkChannelPaymentCons = mainCons.reportAll.sdkChannelPaymentCons;
                $scope.countryPaymentCons = angular.copy(mainCons.reportAll.countryPaymentCons);
                $scope.showSearchCountryDlg = showSearchCountryDlg;
                $scope.teamUser = AUI.HDGWCall.getUserInfoValue('teamid')
                $scope.today = new Date();
                $scope.query = {
                    // 传递哪些筛选条件，哪些筛选条件就展示。全集如下
                    appId: '-1',                    //【产品下拉框】【默认值】-1
                    appName: '',
                    appTaskId: '-1',
                    runEntry: '-1',
                    appTaskIdFun: null,
                    appListQueryMethod: null,     //【产品下拉框查询方法】默认值是调用openDeveloper的GetProductList。 如果各个子页面不一样，可以定制. 定制的resolve结果必须是数组
                    regionShow: [0, 7, 5, 6],           //【展示哪些时间段】【默认值】[0,4,5,6]【枚举】0:自定义 1 今天 2 昨天 3 上周 4 前七天 5 本月 6 上月 7 本周  8 过去一个月 9 过去两个月
                    regionType: 0,                   //【时间段】【默认值】0 【枚举】0:自定义1 今天 2 昨天 3 上周 4 前七天 5 本月 6 上月 7 本周  8 过去一个月 9 过去两个月
                    startTime: new Date(),           //【开始时间】【默认值】今天
                    endTime: new Date(),             //【结束时间】【默认值】今天
                    timeQuantum: -1,                 //【允许的时间跨度】默认值是不限制
                    todayCheck: 'Y',                 //【是否校验开始时间不能等于今天】
                    queryType: 1,                    //【时间类型】【默认值】1【枚举】1:购买时间2:退款时间
                    billTime: new Date(),            //【账单时间】【默认值】上个月
                    settleType: 'ALL',                //【结算方式】【默认值】ALL【枚举】ALL:全部CPP:CPP CPA:CPA
                    status: '-1',                      //【结算状态】【默认值】-1【枚举】-1:全部0:待确认1:已确认
                    tradeId: '',                     //【订单编号】【默认值】空
                    tradeStatus: -1,          //【订单状态】【默认值】-1【枚举】-1:全部状态1:预扣2:确认扣除3:预扣解除4:直接扣除成功5:直接扣除失败6:退款成功
                    tradeStatusGameTicket: -1,     //【订单状态】【默认值】-1【枚举】-1:全部状态1:预扣2:确认扣除3:预扣解除4:直接扣除成功5:直接扣除失败6:退款成功
                    sdkChannel: -1,                  //【推广渠道】【默认值】-1【枚举】-1:全部0:华为应用1:华为应用市场渠道2:预装渠道，3:游戏吧
                    sdkChannelQueryType: "time",  //【查看方式】【默认值】time【枚举】time:日期app:应用payType:支付方式
                    queryMethod: '',                //【查询方法】必填。点击查询调用的方法
                    queryMethodPreventSync: '',   //【查询方法的保护形式】默认查询的保护是单接口保护，如果需要异步保护，设置这个值
                    downloadMethod: '',             //【下载方法】非必填。点击下载调用的方法。 如果不填，表示不展示下载按钮
                    downloadMethodPreventSync: '',//【下载方法的保护形式】默认查询的保护是单接口保护，如果需要异步保护，设置这个值
                    onload: null,
                    installContentAll: -1,
                    installContentSum: -1,
                    installContentDay: -1,
                    installContentNew: -1,
                    installContentUpdate: -1,
                    installContentChange: null,
                    activationContentAll: 0,
                    activationContentSum: -1,
                    activationContentNew: -1,
                    activationContentChange: null,
                    adType: -1,                        //广告形式 默认值】-1 【枚举】-1：全部0:开屏1:锁屏
                    RegionnalSortType: 1,            //地域分析 选择排序】1【枚举】1:安装量2:激活量
                    RegionnalTop: 10,                 //地域分析 选择地域】10【枚举】10:top10 2:top20
                    province: "",                     //地域分析 选择地域】【默认值】空
                    topTerminalTop: 10,              //机型分析 选择机型】1【枚举】10：top10 20:top20
                    topTerminalSortType: 'increasedDay',//机型分析 选择排序】increasedDay【枚举】increasedDay:安装量activationDay:激活量
                    os: [],
                    watchContentAll: 1,
                    watchContentInstall: 11,            //地域分析|机型分析】查看内容
                    watchContentActivation: 12,           //地域分析|机型分析】查看内容
                    versionContent: 1,                   //机型分析  查看内容
                    versionTop: 5,                       //机型分析 选择排序】5:top5 10:top10 0:自定义
                    versionVer: '',                    //机型分析 自定义 值
                    versionOs: [],                      //机型分析】选择os系统
                    watchContentPortraitAll: 1,           //画像分析 查看内容
                    watchContentPortraitInstall: 11,      //画像分析 查看内容
                    watchContentPortraitActivation: 12,   //画像分析 查看内容
                    watchContentPeopleAll: 1,             //画像分析 选择任务属性
                    watchContentPeopleSex: 11,        //画像分析 选择任务属性
                    watchContentPeopleAge: 12,      //画像分析 选择任务属性
                    requestAll: -1,                   //广告效果报表 请求量
                    impressionAll: 1,                 //广告效果报表 展现量
                    clickAll: -1,                      //广告效果报表 点击量
                    fillRate: -1,                      //广告效果报表 填充率
                    clickRate: -1,                     //广告效果报表 点击率
                    income: 1,                          //广告效果报表 收入
                    tradeStatusPayment: -1,           // 支付订单状态
                    serviceTypePayment: -1,           // 支付订单业务类型
                    payTypePayment: -1,               // 支付订单支付方式
                    sdkChannelPayment: -1,            // 支付订单推广方式
                    countryPayment: 'ALL', //支付订单【国家】
                    countryCodes: '',//多选国家查询
                    orderNo: '', //支付订单【华为订单号】【默认值】空
                    merchantOrderId: '', //商户订单号
                    tabType: '', //payment--支付明细gameTicket--优惠券明细
                    //区别主题报表和其他报表
                    isTheme: false,
                    viewDownloadList: ''
                };

                $scope.appList = [];
                $scope.runEntryList = [],
                    $scope.appTaskList = [];

                ngModelCtrl.$formatters.push(function (modelValue) {
                    for (var filedName in $scope.query) {
                        setDefaultValue(filedName, modelValue);
                    }

                    if (typeof $scope.query.appId != 'undefined') {
                        if (typeof $scope.query.appListQueryMethod == 'function') {
                            $scope.query.appListQueryMethod().then(function (data) {
                                // 云文件夹推广报表特殊处理
                                if ($scope.query.appId == '-2') {
                                    $scope.query.appId = '-1';
                                    $scope.appList = [{
                                        prodID: '-1',
                                        prodName: '全部任务'
                                    }].concat(data);
                                } else if ($scope.query.appId == '-3' || $scope.query.appId == '-19') {
                                    $scope.appList = data;
                                } else if ($scope.query.appId == '-1' && $scope.query.isTheme) {
                                    $scope.appList = [{
                                        prodID: '-1',
                                        prodName: '全部主题'
                                    }].concat(data);
                                } else {
                                    $scope.appList = [{
                                        prodID: '-1',
                                        prodName: '全部应用'
                                    }].concat(data);
                                }

                                // 置灰
                                // 因为是异步请求，必须加载完成后再初始化页面
                                initPage();
                            })
                        }
                    } else {
                        initPage();
                    }
                });

                function initPage() {
                    // 设置产品列表的默认选择：
                    if (typeof $scope.query.appId != 'undefined') {
                        $scope.query.appId = setDefaultSelect($scope.query.appId, $scope.appList, "prodID");
                        $scope.query.appName = setDefaultSelect($scope.query.appName, $scope.appList, "prodName");
                    }

                    // 设置免安装应用运行入口默认选择：
                    if (typeof $scope.query.runEntry != 'undefined') {
                        // 请求参数
                        var request = {
                            appId: '-1',
                            startTime: "2018-01-01",
                            endTime: "2018-01-01",
                            pageNum: 1,
                            pageSize: 100000
                        };
                        // 查询运行入口列表
                        OpenOther.getReportBI({reportType: 'getRunEntryList', params: request}).then(function (resp) {
                            $scope.runEntryList = [{
                                entryId: '-1',
                                entryName: '全部'
                            }].concat(resp.result);
                            $scope.query.runEntry = setDefaultSelect($scope.query.entryId, $scope.runEntryList, "entryId");
                        });
                    }

                    // 设置订单状态的默认选择：
                    if (typeof $scope.query.tradeStatus != 'undefined') {
                        $scope.query.tradeStatus = setDefaultSelect($scope.query.tradeStatus, $scope.tradeStatusMarketCons, "id");
                    }
                    // 设置订单状态的默认选择：
                    if (typeof $scope.query.tradeStatusGameTicket != 'undefined') {
                        $scope.query.tradeStatusGameTicket = setDefaultSelect($scope.query.tradeStatusGameTicket, $scope.tradeStatusGameTicketCons, "id");
                    }
                    // 设置订单状态的默认选择：
                    if (typeof $scope.query.sdkChannel != 'undefined') {
                        $scope.query.sdkChannel = setDefaultSelect($scope.query.sdkChannel, $scope.tradeSDKCons, "id");
                    }
                    // 设置订单状态的默认选择：
                    if (typeof $scope.query.sdkChannelQueryType != 'undefined') {
                        $scope.query.sdkChannelQueryType = setDefaultSelect($scope.query.sdkChannelQueryType, $scope.tradeSDKQueryTypeCons, "id");
                    }
                    // 根据regionType设置默认查询的开始时间和结束时间
                    if (typeof $scope.query.regionType != 'undefined' && $scope.query.regionType != 0) {
                        $scope.changeDateType($scope.query.regionType);
                    }
                    // 设置结算方式的默认选择：
                    if (typeof $scope.query.settleType != 'undefined') {
                        $scope.query.settleType = setDefaultSelect($scope.query.settleType, $scope.preSettlementSettleTypeCons, "id");
                    }
                    // 设置结算状态的默认选择：
                    if (typeof $scope.query.status != 'undefined') {
                        $scope.query.status = setDefaultSelect($scope.query.status, $scope.preSettlementStatusCons, "id");
                    }
                    // 设置支付订单状态默认选择：
                    if (typeof $scope.query.tradeStatusPayment != 'undefined') {
                        $scope.query.tradeStatusPayment = setDefaultSelect($scope.query.tradeStatusPayment, $scope.tradeStatusPaymentCons, "id");
                    }
                    // 设置支付订单业务类型默认选择：
                    if (typeof $scope.query.serviceTypePayment != 'undefined') {
                        $scope.query.serviceTypePayment = setDefaultSelect($scope.query.serviceTypePayment, $scope.serviceTypePaymentCons, "id");
                    }
                    // 设置支付订单支付方式默认选择：
                    if (typeof $scope.query.payTypePayment != 'undefined') {
                        $scope.query.payTypePayment = setDefaultSelect($scope.query.payTypePayment, $scope.payTypePaymentCons, "id");
                    }
                    // 设置支付订单推广渠道默认选择：
                    if (typeof $scope.query.sdkChannelPayment != 'undefined') {
                        $scope.query.sdkChannelPayment = setDefaultSelect($scope.query.sdkChannelPayment, $scope.sdkChannelPaymentCons, "id");
                    }


                    // 设置支付订单国家默认选择：
                    if (typeof $scope.query.countryPayment != 'undefined') {
                        auiTeamAccountService.getRealNameCountryList().then(function (data) {
                            var countryCodeList = mainCons.reportAll.countryCodeList;
                            var newCountryList = [];
                            countryCodeList.forEach(function(code) {
                                data.allContrysFromInterface.forEach(function(item) {
                                    if(code === item.country) {
                                        newCountryList.push({simple: code, countryName: item.normalName})
                                    }
                                })
                            })
                            $scope.countryPaymentCons = newCountryList;
                            $scope.countryPaymentCons = $scope.countryPaymentCons.concat(sysParamCfg.unSuportCountryInfo);
                            $scope.countryPaymentCons.unshift({simple: 'ALL', countryName: '全部国家/地区'});
                            $scope.query.countryPayment = setDefaultSelect($scope.query.countryPayment, $scope.countryPaymentCons, "simple");
                        });
                    }
                    //
                    $scope.queryBackUp = angular.copy($scope.query);

                    setModel();
                    // 全部设置好了之后，设置Model，
                    $scope.$watch('query', setModel, true);
                    // 调用初始化方法
                    if (typeof $scope.query.onload == 'function') {
                        $scope.query.onload();
                    }
                }

                function showSearchCountryDlg() {
                    reportUtil.showSearchCountryDlg({
                        callBack: function (countryCodes, countryNames) {
                            $scope.query.countryNames = countryNames;
                            $scope.query.countryCodes = countryCodes;
                        }
                    });
                }


                function setDefaultSelect(key, list, listField) {
                    var selected;
                    // 根据入参的app设置当前选择的值
                    for (var i in list) {
                        if (list[i][listField] == key) {
                            selected = list[i];
                        }
                    }
                    if (typeof selected == 'undefined') {

                        if (typeof $scope.query.versionTop != 'undefined' && list.length > 1) {

                            selected = list[1];
                        } else {
                            // 默认选择“全部应用”
                            selected = list[0];
                        }

                    }
                    return selected;
                }

                $scope.backup = function () {
                    $scope.query = angular.copy($scope.queryBackUp)
                };
                $scope.changeDateType = function (type) {
                    $scope.query.regionType = type;
                    if (type != 0) {
                        var newDate = AUI.DateUtil.calDateByType(type);
                        $scope.query.endTime = newDate.endDate;
                        $scope.query.startTime = newDate.startDate;
                    }
                };
                $scope.changeRegionnalTop = function () {
                    $scope.query.province = '';
                };
                $scope.checkAdapter = function (type, scope) {

                    if (scope == 1) {
                        if (type == 1) {
                            if ($scope.query.watchContentAll == 1) {
                                $scope.query.watchContentInstall = 11;
                                $scope.query.watchContentActivation = 12;
                            } else {
                                $scope.query.watchContentInstall = -1;
                                $scope.query.watchContentActivation = -1;
                            }

                        } else if ($scope.query.watchContentInstall == 11 && $scope.query.watchContentActivation == 12) {
                            $scope.query.watchContentAll = 1;
                        } else {
                            $scope.query.watchContentAll = -1;
                        }

                    } else if (scope == 2) {
                        if (type == 1) {
                            if ($scope.query.watchContentPortraitAll == 1) {
                                $scope.query.watchContentPortraitInstall = 11;
                                $scope.query.watchContentPortraitActivation = 12;
                            } else {
                                $scope.query.watchContentPortraitInstall = -1;
                                $scope.query.watchContentPortraitActivation = -1;
                            }

                        } else if ($scope.query.watchContentPortraitInstall == 11 && $scope.query.watchContentPortraitActivation == 12) {
                            $scope.query.watchContentPortraitAll = 1;
                        } else {
                            $scope.query.watchContentPortraitAll = -1;
                        }
                    } else if (scope == 3) {
                        if (type == 1) {
                            if ($scope.query.watchContentPeopleAll == 1) {
                                $scope.query.watchContentPeopleSex = 11;
                                $scope.query.watchContentPeopleAge = 12;
                            } else {
                                $scope.query.watchContentPeopleSex = -1;
                                $scope.query.watchContentPeopleAge = -1;
                            }

                        } else if ($scope.query.watchContentPeopleSex == 11 && $scope.query.watchContentPeopleAge == 12) {
                            $scope.query.watchContentPeopleAll = 1;
                        } else {
                            $scope.query.watchContentPeopleAll = -1;
                        }
                    }
                    //不需要重新加载下拉框标记'NO'
                    setModel(null, 'NO');
                };
                $scope.showMoreFiled = function () {
                    return typeof $scope.query['tradeId'] != 'undefined'
                        || typeof $scope.query['tradeStatus'] != 'undefined'
                        || typeof $scope.query['merchantOrderId'] != 'undefined'
                        || typeof $scope.query['sdkChannel'] != 'undefined'
                        || typeof $scope.query['sdkChannelQueryType'] != 'undefined'
                        || typeof $scope.query['adType'] != 'undefined'
                        || typeof $scope.query['RegionnalSortType'] != 'undefined'
                        || typeof $scope.query['RegionnalTop'] != 'undefined'
                        || typeof $scope.query['topTerminalSortType'] != 'undefined'
                        || typeof $scope.query['topTerminalTop'] != 'undefined'
                        || typeof $scope.query['watchContentInstall'] != 'undefined'
                        || typeof $scope.query['watchContentActivation'] != 'undefined'
                        || typeof $scope.query['watchContentAll'] != 'undefined'
                        || typeof $scope.query['versionContent'] != 'undefined'
                        || typeof $scope.query['watchContentPortraitAll'] != 'undefined'
                        || typeof $scope.query['installContentAll'] != 'undefined'
                        || typeof $scope.query['activationContentAll'] != 'undefined'
                        || typeof $scope.query['orderNo'] != 'undefined';
                };

                $scope.tipShow = function () {
                    if ($scope.query.tabType == 'gameTicket') {
                        return true;
                    }

                    return false;
                };

                $scope.filedShow = function (filedName) {
                    return typeof $scope.query[filedName] != 'undefined'
                };

                $scope.regionShow = function (type) {
                    if ($scope.query.regionShow) {
                        for (var i in $scope.query.regionShow) {
                            if ($scope.query.regionShow[i] == type) {
                                return true;
                            }
                        }
                    }
                    return false;
                };

                function setDefaultValue(fieldName, modelValue) {
                    if (typeof modelValue[fieldName] != 'undefined') {
                        $scope.query[fieldName] = modelValue[fieldName];
                    } else {
                        delete $scope.query[fieldName];
                    }
                }


                $scope.reSetVersionOs = function () {
                    $scope.query.versionVer = '';
                };
                $scope.changeAll4Install = function (index) {
                    if (index == 0) {
                        $scope.query.installContentSum = $scope.query.installContentAll;
                        $scope.query.installContentDay = $scope.query.installContentAll;
                        $scope.query.installContentNew = $scope.query.installContentAll;
                        $scope.query.installContentUpdate = $scope.query.installContentAll;
                    } else if ($scope.query.installContentSum == 1 && $scope.query.installContentDay == 1 && $scope.query.installContentNew == 1 && $scope.query.installContentUpdate == 1) {
                        $scope.query.installContentAll = 1
                    } else {
                        $scope.query.installContentAll = -1
                    }
                    setModel();
                };
                $scope.changeAll4Activation = function (index) {
                    if (index == 0) {
                        $scope.query.activationContentSum = $scope.query.activationContentAll;
                        $scope.query.activationContentNew = $scope.query.activationContentAll;
                    } else if ($scope.query.activationContentSum == 1 && $scope.query.activationContentNew == 1) {
                        $scope.query.activationContentAll = 1
                    } else {
                        $scope.query.activationContentAll = -1
                    }
                    setModel();
                };

                function reportVersionOsList(newValue, oldQuery) {
                    // 除了时间和应用控件，其他控件的变更。不需要重新加载下拉框,直接赋值即可.
                    var flag = isRetLoad(newValue, oldQuery);
                    if (!flag) {
                        newValue.versionOs = $scope.query.versionOs;
                        newValue.versionVer = $scope.query.versionVer.version;
                        ngModelCtrl.$setViewValue(newValue);
                        return;
                    }
                    var params = {
                        appId: newValue.appId,//newValue.appId,1009841788
                        startTime: newValue.startTime,
                        endTime: AUI.DateUtil.getEndTime(newValue.endTime)
                    };
                    OpenOther.getReportAppVersionOsListBI(params).then(function (resp) {

                        if (resp && resp.reportAppVersionChartList && resp.reportAppVersionTableList) {

                            $scope.versionOsList = resp.reportAppVersionChartList;
                            $scope.versionVerCons = resp.reportAppVersionTableList;
                            $scope.query.versionOs = [];
                            newValue.versionOs = $scope.query.versionOs;
                            $scope.query.versionVer = '';
                            newValue.versionVer = $scope.query.versionVer.version;
                            ngModelCtrl.$setViewValue(newValue);
                        }

                    }).catch(function () {
                        ngModelCtrl.$setViewValue(newValue);
                    })
                }

                function reportTerminalTypeList(newValue, oldQuery) {
                    // 除了时间和应用控件，其他控件的变更。不需要重新加载下拉框,直接赋值即可.
                    var flag = isRetLoad(newValue, oldQuery);
                    if (!flag) {
                        newValue.os = $scope.query.os;
                        ngModelCtrl.$setViewValue(newValue);
                        return;
                    }
                    var params = {
                        appId: newValue.appId,
                        startTime: newValue.startTime,
                        endTime: AUI.DateUtil.getEndTime(newValue.endTime)
                    };
                    OpenOther.getReportTerminalOsSelectBI(params).then(function (resp) {

                        if (parseInt(resp.returnCode, 10) === 200) {

                            $scope.reportTerminalTypeList = resp.reportTerminalTypeList;
                            $scope.query.os = [];
                            newValue.os = $scope.query.os;
                            ngModelCtrl.$setViewValue(newValue);
                        }

                    }).catch(function () {

                        ngModelCtrl.$setViewValue(newValue);
                    })
                }

                /**
                 * 只有时间和应用id变更在重新加载版本和os下拉框
                 */
                function isRetLoad(newValue, oldQuery) {
                    var isLoad = false;

                    if (!oldQuery) {
                        isLoad = true;
                        return isLoad;
                    }
                    if (oldQuery && oldQuery == 'NO') {
                        return isLoad;
                    }
                    var newStartTime = newValue.startTime;
                    var oldStartTime = oldQuery.startTime;
                    if (angular.isDate(oldStartTime)) {
                        oldStartTime = AUI.DateUtil.date2Str(oldStartTime);
                    }
                    var timeQuantum = AUI.DateUtil.calDaysDual(newStartTime, oldStartTime);
                    if (timeQuantum != 1) {
                        isLoad = true;
                        return isLoad;
                    }
                    var newEndTime = newValue.endTime;
                    var oldEndTime = oldQuery.endTime;
                    if (angular.isDate(oldEndTime)) {
                        oldEndTime = AUI.DateUtil.date2Str(oldEndTime);
                    }
                    timeQuantum = AUI.DateUtil.calDaysDual(newEndTime, oldEndTime);
                    if (timeQuantum != 1) {
                        isLoad = true;
                        return isLoad;
                    }
                    var newAppId = newValue.appId;
                    var oldAppId = oldQuery.appId.prodID;
                    if (newAppId != oldAppId) {
                        isLoad = true;
                        return isLoad;
                    }
                    return isLoad;
                }

                function setModel(newQuery, oldQuery) {
                    var newValue = {};
                    if (typeof $scope.query.appId != 'undefined') {
                        newValue.appId = $scope.query.appId.prodID;
                        newValue.appName = $scope.query.appId.prodName;
                    }
                    if (typeof $scope.query.appTaskId != 'undefined') {
                        newValue.appTaskId = $scope.query.appTaskId;
                    }
                    if (typeof $scope.query.queryType != 'undefined') {
                        newValue.queryType = $scope.query.queryType;
                    }

                    processTime(newQuery, oldQuery, newValue);

                    if (typeof $scope.query.billTime != 'undefined') {
                        var billTime = $scope.query.billTime;
                        if (angular.isDate(billTime)) {
                            billTime = AUI.DateUtil.date2Str(billTime);
                        }
                        newValue.billTime = billTime;
                    }
                    if (typeof $scope.query.settleType != 'undefined') {
                        newValue.settleType = $scope.query.settleType;
                    }
                    if (typeof $scope.query.runEntry != 'undefined') {
                        newValue.runEntry = $scope.query.runEntry;
                    }
                    if (typeof $scope.query.status != 'undefined') {
                        newValue.status = $scope.query.status;
                    }
                    if (typeof $scope.query.tradeId != 'undefined') {
                        newValue.tradeId = $scope.query.tradeId;
                    }
                    if (typeof $scope.query.merchantOrderId != 'undefined') {
                        newValue.merchantOrderId = $scope.query.merchantOrderId;
                    }
                    if (typeof $scope.query.tradeStatus != 'undefined') {
                        newValue.tradeStatus = $scope.query.tradeStatus.id;
                    }
                    if (typeof $scope.query.tradeStatusGameTicket != 'undefined') {
                        newValue.tradeStatusGameTicket = $scope.query.tradeStatusGameTicket.id;
                    }
                    if (typeof $scope.query.tradeStatusPayment != 'undefined') {
                        newValue.tradeStatusPayment = $scope.query.tradeStatusPayment.id;
                    }
                    if (typeof $scope.query.serviceTypePayment != 'undefined') {
                        newValue.serviceTypePayment = $scope.query.serviceTypePayment.id;
                    }
                    if (typeof $scope.query.payTypePayment != 'undefined') {
                        newValue.payTypePayment = $scope.query.payTypePayment.id;
                    }
                    if (typeof $scope.query.sdkChannelPayment != 'undefined') {
                        newValue.sdkChannelPayment = $scope.query.sdkChannelPayment.id;
                    }
                    if (typeof $scope.query.countryPayment != 'undefined') {
                        newValue.countryPayment = $scope.query.countryPayment.simple;
                    }

                    if (typeof $scope.query.countryCodes != 'undefined') {
                        newValue.countryCodes = $scope.query.countryCodes;
                    }
                    if (typeof $scope.query.sdkChannel != 'undefined') {
                        newValue.sdkChannel = $scope.query.sdkChannel.id;
                    }
                    if (typeof $scope.query.sdkChannelQueryType != 'undefined') {
                        newValue.sdkChannelQueryType = $scope.query.sdkChannelQueryType.id;
                    }
                    if (typeof $scope.query.adType != 'undefined') {
                        newValue.adType = $scope.query.adType;
                    }
                    if (typeof $scope.query.RegionnalSortType != 'undefined') {
                        newValue.RegionnalSortType = $scope.query.RegionnalSortType;
                    }
                    if (typeof $scope.query.RegionnalTop != 'undefined') {
                        newValue.RegionnalTop = $scope.query.RegionnalTop;
                    }
                    if (typeof $scope.query.province != 'undefined') {
                        newValue.province = $scope.query.province;
                    }
                    if (typeof $scope.query.topTerminalSortType != 'undefined') {
                        newValue.topTerminalSortType = $scope.query.topTerminalSortType;
                    }
                    if (typeof $scope.query.topTerminalTop != 'undefined') {
                        newValue.topTerminalTop = $scope.query.topTerminalTop;
                    }

                    if (typeof $scope.query.installContentAll != 'undefined') {
                        newValue.installContentAll = $scope.query.installContentAll;
                    }
                    if (typeof $scope.query.installContentSum != 'undefined') {
                        newValue.installContentSum = $scope.query.installContentSum;
                    }
                    if (typeof $scope.query.installContentDay != 'undefined') {
                        newValue.installContentDay = $scope.query.installContentDay;
                    }
                    if (typeof $scope.query.installContentNew != 'undefined') {
                        newValue.installContentNew = $scope.query.installContentNew;
                    }
                    if (typeof $scope.query.installContentUpdate != 'undefined') {
                        newValue.installContentUpdate = $scope.query.installContentUpdate;
                    }

                    if (typeof $scope.query.activationContentAll != 'undefined') {
                        newValue.activationContentAll = $scope.query.activationContentAll;
                    }
                    if (typeof $scope.query.activationContentSum != 'undefined') {
                        newValue.activationContentSum = $scope.query.activationContentSum;
                    }
                    if (typeof $scope.query.activationContentNew != 'undefined') {
                        newValue.activationContentNew = $scope.query.activationContentNew;
                    }

                    if (typeof $scope.query.watchContentAll != 'undefined') {
                        newValue.watchContentAll = $scope.query.watchContentAll;
                    }
                    if (typeof $scope.query.watchContentInstall != 'undefined') {
                        newValue.watchContentInstall = $scope.query.watchContentInstall;
                    }
                    if (typeof $scope.query.watchContentActivation != 'undefined') {
                        newValue.watchContentActivation = $scope.query.watchContentActivation;
                    }

                    if (typeof $scope.query.versionContent != 'undefined') {
                        newValue.versionContent = $scope.query.versionContent;
                    }

                    if (typeof $scope.query.versionTop != 'undefined') {
                        newValue.versionTop = $scope.query.versionTop;
                    }

                    if (typeof $scope.query.versionVer != 'undefined') {
                        newValue.versionVer = $scope.query.versionVer;
                    }

                    if (typeof $scope.query.versionOs != 'undefined') {
                        newValue.versionOs = $scope.query.versionOs;
                    }

                    if (typeof $scope.query.watchContentPortraitAll != 'undefined') {
                        newValue.watchContentPortraitAll = $scope.query.watchContentPortraitAll;
                    }

                    if (typeof $scope.query.watchContentPortraitInstall != 'undefined') {
                        newValue.watchContentPortraitInstall = $scope.query.watchContentPortraitInstall;
                    }

                    if (typeof $scope.query.watchContentPortraitActivation != 'undefined') {
                        newValue.watchContentPortraitActivation = $scope.query.watchContentPortraitActivation;
                    }

                    if (typeof $scope.query.watchContentPeopleAll != 'undefined') {
                        newValue.watchContentPeopleAll = $scope.query.watchContentPeopleAll;
                    }

                    if (typeof $scope.query.watchContentPeopleSex != 'undefined') {
                        newValue.watchContentPeopleSex = $scope.query.watchContentPeopleSex;
                    }

                    if (typeof $scope.query.watchContentPeopleAge != 'undefined') {
                        newValue.watchContentPeopleAge = $scope.query.watchContentPeopleAge;
                    }

                    if (typeof $scope.query.orderNo != 'undefined') {
                        newValue.orderNo = $scope.query.orderNo;
                    }

                    var checkedCount = 0;
                    if (typeof $scope.query.requestAll != 'undefined') {
                        var requestAll = $scope.query.requestAll;
                        if (requestAll == 1) {
                            checkedCount++;
                        }
                        newValue.requestAll = requestAll;
                    }
                    if (typeof $scope.query.impressionAll != 'undefined') {
                        var impressionAll = $scope.query.impressionAll;
                        if (impressionAll == 1) {
                            checkedCount++;
                        }
                        newValue.impressionAll = impressionAll;
                    }
                    if (typeof $scope.query.clickAll != 'undefined') {
                        var clickAll = $scope.query.clickAll
                        if (clickAll == 1) {
                            checkedCount++;
                        }
                        newValue.clickAll = clickAll;
                    }
                    if (typeof $scope.query.fillRate != 'undefined') {
                        var fillRate = $scope.query.fillRate;
                        if (fillRate == 1) {
                            checkedCount++;
                        }
                        newValue.fillRate = fillRate;
                    }
                    if (typeof $scope.query.clickRate != 'undefined') {
                        var clickRate = $scope.query.clickRate;
                        if (clickRate == 1) {
                            checkedCount++;
                        }
                        newValue.clickRate = clickRate;
                    }
                    if (typeof $scope.query.income != 'undefined') {
                        var income = $scope.query.income;
                        if (income == 1) {
                            checkedCount++;
                        }
                        newValue.income = income;
                    }
                    if (typeof $scope.query.requestAll != 'undefined' && checkedCount > 2) {
                        auiDialog.fail("最多能选2个查看");

                    }

                    if (typeof $scope.query.requestAll != 'undefined' && checkedCount == 0) {
                        auiDialog.fail("最少选1个查看");
                    }
                    //需要放在最后,如有添加往前放
                    if (typeof $scope.query.os != 'undefined') {
                        reportTerminalTypeList(newValue, oldQuery);
                    } else if (typeof $scope.query.versionOs != 'undefined') {
                        reportVersionOsList(newValue, oldQuery);
                    } else {
                        ngModelCtrl.$setViewValue(newValue);
                    }
                }

                function processTime(newQuery, oldQuery, newValue) {
                    var startTime = $scope.query.startTime;
                    var endTime = $scope.query.endTime;
                    if (angular.isDate(startTime)) {
                        startTime = AUI.DateUtil.date2Str(startTime);
                    }
                    if (angular.isDate(endTime)) {
                        endTime = AUI.DateUtil.date2Str(endTime);
                    }

                    var gameTicketFlag = false;
                    var crossMonFlag = false;
                    var minStartTime = new Date('2017/11/01');
                    // 检查跨度
                    if (angular.isFunction($scope.query.timeQuantum)) {// 如果是function， 那么把所有的事情：校验规则、处理、提示都交给别人来搞
                        newQuery && oldQuery && $scope.query.timeQuantum($scope.query, newQuery, oldQuery);
                        //errorQuantum = false 这里不需要设置errorTime==true，因为校验完成之后的时间设置，已经交给调用者自己处理了
                    } else {// 如果不是，采用通用检查

                        //优惠券明细管理,不支持跨月，starttime不能早于2017年11月1日
                        if ($scope.query.tabType != undefined && $scope.query.tabType != null) {
                            if ($scope.query.tabType == 'gameTicket') {
                                gameTicketFlag = true;
                                // 计算7年前日期
                                var sevenYearBeforeTime = AUI.DateUtil.calDateByType(20);
                                var sevenYearBeforeStartDate = sevenYearBeforeTime.startDate;
                                var date20171101 = new Date('2017/11/01');
                                //如果7年前时间大于2017/11/01，取最大日期
                                if (sevenYearBeforeStartDate.getTime() > date20171101.getTime()) {
                                    //最小的开始日期为7年前
                                    minStartTime = sevenYearBeforeStartDate;

                                } else {                         			//最小的起始日期2017/11/01
                                    minStartTime = date20171101;

                                }
                                if (AUI.DateUtil.stringToDate(minStartTime).getTime() > AUI.DateUtil.stringToDate(startTime).getTime()) {
                                    startTime = minStartTime;
                                    $scope.query.startTime = minStartTime;
                                }
                                //判断开始日期和结束日期是否在同一个月
                                if (AUI.DateUtil.checkSameYearMonth(startTime, endTime)) {
                                    crossMonFlag = false;
                                } else {
                                    crossMonFlag = true;
                                }


                            } else {
                                gameTicketFlag = false;
                            }
                        }

                        var timeQuantum = AUI.DateUtil.calDaysDual(endTime, startTime);

                        // 第一步，如果需要检查开始时间不能不能大于等于今天， 则检查之
                        var errorToday = false;
                        if (typeof $scope.query.todayCheck != 'undefined' && $scope.query.todayCheck == 'Y') {
                            errorToday = AUI.DateUtil.calDaysDual(startTime, AUI.DateUtil.date2Str($scope.today)) == 1;
                            if (errorToday && !gameTicketFlag) {
                                auiDialog.fail("时间区间选择错误", "开始时间不能大于等于今天");
                            }
                        }

                        // 第二步，检查开始时间不能晚于结束时间
                        var errorCompare = false;
                        if (startTime && endTime && !errorToday) {
                            errorCompare = timeQuantum < 1;
                            if (errorCompare && !gameTicketFlag) {
                                auiDialog.fail("时间区间选择错误", "开始时间不能晚于结束时间。");
                            }
                        }

                        // 第三步，检查跨度的天数是否超过配置的值
                        var errorQuantum = false;
                        if (!errorCompare && !errorToday && typeof $scope.query.timeQuantum != 'undefined' && $scope.query.timeQuantum != -1) {
                            if (angular.isNumber($scope.query.timeQuantum)) { //  如果是数字，表示以天为单位
                                if (timeQuantum < 1 || timeQuantum > $scope.query.timeQuantum) {
                                    errorQuantum = true;
                                }
                            } else if (angular.isString($scope.query.timeQuantum)) {//  如果是String，表示以月为单位
                                if (timeQuantum < 1 || AUI.DateUtil.checkMonthDual(startTime, endTime, parseInt($scope.query.timeQuantum))) {
                                    errorQuantum = true;
                                }
                            }
                        }
                        // 第四步：根据检查的结果以及此次变更的时间，重新设值
                        if (newQuery && oldQuery && (errorCompare || errorToday || errorQuantum || crossMonFlag)) {
                            if (!AUI.DateUtil.compareDate(newQuery.startTime, oldQuery.startTime)) {
                                if (errorToday) {
                                    $scope.query.startTime = AUI.DateUtil.stringToDate(oldQuery.startTime);//开始时间不能大于等于今天
                                } else if (errorQuantum) {//跨度的天超过配置的值
                                    $scope.query.endTime = AUI.DateUtil.calDaysLater(AUI.DateUtil.stringToDate($scope.query.startTime), ($scope.query.timeQuantum - 1));
                                } else if (crossMonFlag) {//开始和结束日期跨月
                                    $scope.query.endTime = AUI.DateUtil.getLastDay($scope.query.startTime);
                                } else {
                                    $scope.query.endTime = AUI.DateUtil.stringToDate($scope.query.startTime);//开始时间不能晚于结束时间
                                }
                            } else if (!AUI.DateUtil.compareDate(newQuery.endTime, oldQuery.endTime)) {
                                if (errorQuantum) {//跨度的天超过配置的值
                                    $scope.query.startTime = AUI.DateUtil.calDaysLater(AUI.DateUtil.stringToDate($scope.query.endTime), -($scope.query.timeQuantum - 1));
                                } else if (crossMonFlag) {//开始和结束日期跨月
                                    $scope.query.startTime = AUI.DateUtil.getMonfirstDay($scope.query.endTime);
                                } else {//开始时间不能晚于结束时间
                                    if (gameTicketFlag) {
                                        $scope.query.startTime = AUI.DateUtil.stringToDate($scope.query.endTime);
                                    } else {
                                        $scope.query.startTime = AUI.DateUtil.calDaysLater(AUI.DateUtil.stringToDate($scope.query.endTime), -1);
                                    }
                                }
                            }
                        }
                    }


                    // 任何时候一旦我手工选择了时间，则把时间跨度的类型设置为自定义
                    if (newQuery && oldQuery && ((AUI.DateUtil.compareDate(newQuery.startTime, oldQuery.startTime) && !AUI.DateUtil.compareDate(newQuery.endTime, oldQuery.endTime))
                        || (!AUI.DateUtil.compareDate(newQuery.startTime, oldQuery.startTime) && AUI.DateUtil.compareDate(newQuery.endTime, oldQuery.endTime)))) {
                        $scope.query.regionType = 0;
                    }
                    if (typeof $scope.query.startTime != 'undefined') {
                        if (angular.isDate(startTime)) {
                            startTime = AUI.DateUtil.date2Str(startTime);
                        }
                        newValue.startTime = startTime;
                    }
                    if (typeof $scope.query.endTime != 'undefined') {
                        if (angular.isDate(endTime)) {
                            endTime = AUI.DateUtil.date2Str(endTime);
                        }
                        newValue.endTime = endTime;
                    }
                }
            }
        };
    }
    ])
        ;
})
;

